import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { GridLegacy as Grid } from '@mui/material';
import {
  ScrollableComponent,
  ClaimsNetwork,
  ClaimsNetworkAffiliated,
} from 'components';

const styles = () => ({});

function SharedAffiliationCharts({ provider }) {
  const patientType = useSelector(({ app }) => app.patientType);
  return (
    // Grid container (spacing={3}) matches the other provider tabs, e.g.
    // ClaimsProviderTab. Without it these Grid items render flush against each
    // other and against the card above, with no gutter between cards.
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ScrollableComponent id='providers'>
          <ClaimsNetwork provider={provider} patientType={patientType} />
          {/*
            Providers Shared Patients Flow (ProviderSankey) is hidden.
            It was previously admin-only: {user.is_admin && <ProviderSankey providerId={provider.id} />}
            Re-add the `ProviderSankey` import from 'providers' and the `user` selector to restore.
          */}
        </ScrollableComponent>
      </Grid>
      <Grid item xs={12}>
        <ScrollableComponent id='affiliated'>
          <ClaimsNetworkAffiliated
            provider={provider}
            patientType={patientType}
          />
        </ScrollableComponent>
      </Grid>
    </Grid>
  );
}

SharedAffiliationCharts.propTypes = {
  provider: PropTypes.object,
  patientType: PropTypes.string,
};

const styled = withStyles(styles)(SharedAffiliationCharts);
export { styled as SharedAffiliationCharts };
